export const itemNames = [
  'KeyW',
  'KeyH',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
];
